import $ from 'jquery';
import React,{useState,useEffect} from 'react';
import {GetImgCertUser_CBack,btnSetColor_CBack,TableDatePicker} from '../function_lib/common_lib';

export function updCategoryMaster(){
    GetImgCertUser_CBack(this,"#upd-category-form","editCategoryDet",function(checkData,checkMsg,userMsg){
      if(checkData===-10){
        alert("Kindly fill required fields");
        return;
      }else {
        //Custom_Alert("Successfully Added",checkMsg,false);
        alert(checkMsg);
        $('#divEditCategory').modal('hide');
        window.location.reload();
      }
    });
}             
  
export const Comp_Edit_Category=(props)=>{
    
    useEffect(()=>{
        //setMyProfile(props.memberProfile);
    },[props.memberProfile])

    //alert(JSON.stringify(props));
        return(<div className="modal fade bd-example-modal-xl"  id="divEditCategory" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl11" role="document">
          <div className="modal-content">
          <div className="modal-header bg-primary">
              <h5 className="modal-title text-white" id="exampleModalLabel">Edit Product</h5>
              <button type="button" className="close text-white" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true" className="text-white">&times;</span>
              </button>
            </div>
            <div className="modal-body">
            {props.memberProfile.length>0?
            <form enctype="multipart/form-data" method="POST" onsubmit="event.preventDefault()" className="contact-form-style form-control11 " name="upd-category-form" id="upd-category-form">
    <input type="hidden" name="curl_type" id="curl_type" value="editCategoryDet" />  
                <input type="hidden" name="m_type" id="m_type" value="editCategoryDet" />
                <input type="hidden" name="res_func" id="res_func" value="okSuccCont" />
                <input type='hidden' name="category_token" id="category_token" value={btoa(props.memberProfile[0]["id"])}/>
        <div class="row">
            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Category Name:</strong></label>
                <input name="category_name" id="category_name" type="text" defaultValue={props.memberProfile[0]["category_name"]} class="form-control required" placeholder="Enter full name" required/>
            </div>

            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Category Code:</strong></label>
                <input name="category_code" id="category_code" type="text" defaultValue={props.memberProfile[0]["category_code"]} class="form-control required" placeholder="Enter full name" required/>
            </div>

            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Rate (Rs.) / Per Form:</strong></label>
                <input name="rate" id="rate" defaultValue={props.memberProfile[0]["rate"]} type="number" class="form-control required" placeholder="Rate" required/>
            </div>
            
            <div class="col-md-12 form-group pl-2 pr-2 mb-4">
                <label class="float-left"><strong>Category Status:</strong></label>
                <select className='form-control required' id="category_status" name="category_status">
                    <option value={"0"}>-Select-</option>
                    <option selected={props.memberProfile[0]["category_status"]==="Active"} value={"Active"}>Active</option>
                    <option selected={props.memberProfile[0]["category_status"]==="Inactive"} value={"Inactive"}>Inactive</option>
                </select>
            </div>
          
        </div>

        <div class="text-center mt-4">
            <button type="button" onClick={()=>updCategoryMaster()} class="btn btn-primary me-2">Update</button>
            {/* <button type="reset" class="btn btn-secondary">Reset</button> */}
        </div>
    </form>:''}
          </div>
          </div>
          </div>
          </div>);
    
}
export default Comp_Edit_Category;
